import { create } from 'zustand';
import { DateRange } from 'react-day-picker';
import { ColumnState } from 'ag-grid-community';

import { defaultEQM2020_R01Dto, EQM2020_R01Dto } from './Dto_EQM2020_R01';

export interface EQM2020_R01Filter {
	eqmType: string;
	inspectType: string;
	inspectUse: string;
}

export interface Store_EQM2020_R01 {
	EQM2020_R01Filter: EQM2020_R01Filter;
	EQM2020_R01PastFilter: EQM2020_R01Filter;
	setEQM2020_R01Filter: (filter: Partial<EQM2020_R01Filter>) => void;
	setEQM2020_R01PastFilter: (filter: Partial<EQM2020_R01Filter>) => void;

	EQM2020_R01List: EQM2020_R01Dto[];
	setEQM2020_R01List: (EQM2020_R01List: EQM2020_R01Dto[]) => void;
	insertEQM2020_R01List: (data: EQM2020_R01Dto[], index?: number) => void;
	removeEQM2020_R01List: (index: number) => void;
	updateEQM2020_R01List: (index: number, EQM2020_R01List: EQM2020_R01Dto) => void;

	deletedEQM2020_R01List: string[];
	addDeletedEQM2020_R01List: (idList: string[]) => void;
	removeDeletedEQM2020_R01List: (idList?: string[]) => void;

	selectedEQM2020_R01List: string[];
	setSelectedEQM2020_R01List: (idList: string[]) => void;
	addSelectedEQM2020_R01List: (idList: string[]) => void;
	removeSelectedEQM2020_R01List: (idList?: string[]) => void;
	initSelectedEQM2020_R01List: () => void;
	allSelectedEQM2020_R01List: () => void;

	originalEQM2020_R01List: EQM2020_R01Dto[];
	setOriginalEQM2020_R01List: (list: EQM2020_R01Dto[]) => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	

	initData: () => void;

}

export const defaultEQM2020_R01Filter: EQM2020_R01Filter = {
	eqmType: '',
	inspectType: '',
	inspectUse: ''
};

export const useEQM2020_R01Store = create<Store_EQM2020_R01>((set) => ({
	EQM2020_R01Filter: defaultEQM2020_R01Filter,
	EQM2020_R01PastFilter: defaultEQM2020_R01Filter,
	setEQM2020_R01Filter: (update) => set((state) => ({
		EQM2020_R01Filter: {
			...state.EQM2020_R01Filter,
			...update
		}
	})),
	setEQM2020_R01PastFilter: (update) => set((state) => ({
		EQM2020_R01PastFilter: {
			...state.EQM2020_R01PastFilter,
			...update
		}
	})),

	EQM2020_R01List: [],
	setEQM2020_R01List: (EQM2020_R01List: EQM2020_R01Dto[]) => set((state) => {
		let newList: EQM2020_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		EQM2020_R01List.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultEQM2020_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			EQM2020_R01List: newList
		}
	}),
	insertEQM2020_R01List: (data: EQM2020_R01Dto[], index?: number) => set((state) => {
		let newEQM2020_R01List = [...state.EQM2020_R01List];

		let targetRowData = newEQM2020_R01List.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newEQM2020_R01List.map(item => item.valueIndex || 0)) + 1;

		// newEQM2020_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newEQM2020_R01List.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newEQM2020_R01List에 대체
		newEQM2020_R01List = newEQM2020_R01List.filter(item => item.orderIndex !== targetOrderIndex);
		newEQM2020_R01List.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultEQM2020_R01Dto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newEQM2020_R01List.splice(index, 0, ...newData);
		} else {
			newEQM2020_R01List.push(...newData);
		}
		
		return {
			...state,
			EQM2020_R01List: newEQM2020_R01List
		}
	}),
	removeEQM2020_R01List: (index: number) => set((state) => {
		const newEQM2020_R01List = [...state.EQM2020_R01List].filter((item) => item.valueIndex !== index);
		return {
			...state,
			EQM2020_R01List: newEQM2020_R01List
		}
	}),
	updateEQM2020_R01List: (valueIndex: number, data: EQM2020_R01Dto) => set((state) => {
		const _EQM2020_R01List = state.EQM2020_R01List.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			EQM2020_R01List: _EQM2020_R01List
		}
	}),


	deletedEQM2020_R01List: [],
	addDeletedEQM2020_R01List: (idList: string[]) => set((state) => {
		const _deletedEQM2020_R01List = [...state.deletedEQM2020_R01List];

		for(const valueIndex of idList) {
			const isInserted = state.EQM2020_R01List.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.EQM2020_R01List.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedEQM2020_R01List.push(valueIndex);
			}
		}
		return {
			...state,
			deletedEQM2020_R01List: _deletedEQM2020_R01List
		}
	}),
	removeDeletedEQM2020_R01List: (idList?: string[]) => set((state) => ({
		...state,
		deletedEQM2020_R01List: [...state.deletedEQM2020_R01List].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedEQM2020_R01List: [],
	setSelectedEQM2020_R01List: (idList: string[]) => set({ selectedEQM2020_R01List: idList }),
	addSelectedEQM2020_R01List: (idList: string[]) => set((state) => {
		const _selectedEQM2020_R01List = [...state.selectedEQM2020_R01List];
		if(idList.length > 0) {
			_selectedEQM2020_R01List.push(...idList);
		}
		return {
			...state,
			selectedEQM2020_R01List: _selectedEQM2020_R01List
		}
	}),
	removeSelectedEQM2020_R01List: (idList?: string[]) => set((state) => ({
		...state,
		selectedEQM2020_R01List: [...state.selectedEQM2020_R01List].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedEQM2020_R01List: () => set({ selectedEQM2020_R01List: [] }),
	allSelectedEQM2020_R01List: () => set((state) => {
		const _selectedEQM2020_R01List = [...state.EQM2020_R01List.map(item => item.valueIndex.toString())];
		return {
			...state,
			selectedEQM2020_R01List: _selectedEQM2020_R01List
		}
	}),

	originalEQM2020_R01List: [],
	setOriginalEQM2020_R01List: (EQM2020_R01List: EQM2020_R01Dto[]) => set((state) => {
		let newList: EQM2020_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		EQM2020_R01List.forEach((item, index) => {
			newList.push({ 
				...defaultEQM2020_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalEQM2020_R01List: newList
		}
	}),

	columnState: null,				setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	initData: () => set((state) => ({
		...state,
		EQM2020_R01Filter: defaultEQM2020_R01Filter,
		EQM2020_R01PastFilter: defaultEQM2020_R01Filter,
		EQM2020_R01List: [],
		selectedEQM2020_R01List: [],
		deletedEQM2020_R01List: [],
		allCount: 0,
		scrollTop: null,
	})),

}));